
export const back = ({
    fallbackAction,
    timeoutMilliseconds = 100,
}:{
    fallbackAction       : () => Promise<void>,
    timeoutMilliseconds ?: number,
}): Promise<void> => {
    if (window.history.length === 1) {
        return fallbackAction();
    }

    return new Promise(resolve => {
        const popstateListener = () => {
            clearTimeout(timeoutId);
            resolve();
        };

        const timeoutId = window.setTimeout(() => {
            window.removeEventListener("popstate", popstateListener);
            fallbackAction().then(resolve);
        }, timeoutMilliseconds);

        window.addEventListener("popstate", popstateListener, {once: true});

        window.history.back();
    });
};

